import {
  TBusiness,
  TCreateReceiptBody,
  TCreateReceiptResponse,
} from "@elixir/types";
import { GET_TRYST_HOST, RECEIPT_DOMAIN } from "../constants/env";
import { TrystGenericResponse } from "../types/tryst";
import fetchWrapper from "../fetch-client";

export default async function createReceiptForBusiness({
  businessId,
  doctor_oid,
  payload,
  meta,
  isFromQuickReceipt,
  shouldGeneratePDF,
  abhaId,
}: {
  businessId: TBusiness["business_id"];
  doctor_oid?: string;
  isFromQuickReceipt?: boolean;
  shouldGeneratePDF?: boolean;
  abhaId?: string;
} & TCreateReceiptBody): Promise<TrystGenericResponse<TCreateReceiptResponse>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const Reqpayload: TCreateReceiptBody & {
      doctor_oid?: string;
      abhaId?: string;
    } = { payload, meta, doctor_oid, abhaId };


    const fileNameReceiptV2 = `v2/${businessId}/${doctor_oid}/${meta.clinic_id}/${new Date().getTime()}.pdf`;
    if (shouldGeneratePDF) {
      Reqpayload["pdf_url"] = `${RECEIPT_DOMAIN()}/${fileNameReceiptV2}`;
    }

    const body = JSON.stringify(Reqpayload);

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };

    const response = await fetchWrapper(
      `${TRYST_HOST}/business/${businessId}/receipt`,
      requestOptions
    );

    const result = await (response?.json() || {});
    if (!response?.ok || !response?.status) {
      throw new Error(result?.error || "Could not create receipt");
    }

    return {
      ...(result || {}),
      generatedFileName: fileNameReceiptV2,
    };
  } catch (error: any) {
    const errorMsg =
      typeof error === "string"
        ? error
        : error?.message || "Failed to create receipt";

    return {
      success: false,
      error: errorMsg,
    };
  }
}
